<template>
  <v-app-bar color height="60" dark app fixed :flat="isFlat" class="toolbarPrincipal">
    <div id="iconMenu">
      <v-app-bar-nav-icon @click.stop="$emit('toggleMini', $vuetify.breakpoint.lgAndUp)"></v-app-bar-nav-icon>
    </div>
    <v-toolbar-title>TecPresence</v-toolbar-title>

    <v-spacer></v-spacer>

    <v-menu
      v-model="menuUsuario"
      :close-on-content-click="false"
      :nudge-width="210"
      content-class="menuDerecha"
      offset-x
      offset-y
    >
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-avatar color="blue-grey lighten-1" size="32px">
            <span class="white--text">{{ !!user ? user.initials : '' }}</span>
          </v-avatar>
        </v-btn>
      </template>
      <v-card>
        <v-list>
          <v-list-item avatar>
            <v-list-item-avatar>
              <v-avatar color="blue-grey lighten-1" size="40px">
                <span class="white--text">{{ !!user ? user.initials : '' }}</span>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ !!user ? user.displayName :'' }}</v-list-item-title>
              <v-list-item-subtitle class="mt-1">
                {{ !!user ? user.username:'' }}
                <br />
                {{ !!user ? user.email:'' }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>

        <v-list class="acciones">
          <v-list-item key="cambiarClave">
            <v-list-item-action>
              <v-icon>how_to_reg</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                <router-link :to="{path: '/cambiar-clave', params: {}}">Cambiar contraseña</router-link>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item key="cerrarsesion">
            <v-list-item-action>
              <v-icon>power_settings_new</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                <router-link to="#" v-on:click.native="dialogCerrarSesion=true;menuUsuario=false;">Cerrar sesión</router-link>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
    <v-dialog v-model="dialogCerrarSesion" width="500">
      <v-card class="elevation-12">
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            <span>¿Desea cerrar sesión?</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <p class="mt-5">
            ¿Seguro de sea cerrar la sesión en TecPrecense?
          </p>
          <v-btn color="primary" @click="cerrarSesion" class="mr-5">Si, cerrar sesión</v-btn>
          <v-btn color="default" @click="dialogCerrarSesion=false">No</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app-bar>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import ClickOutside from "vue-click-outside";

export default {
  computed: {
    ...mapState("global", ["drawer", "mini"]),
    busquedaGlobal: function() {
      return ""; //this.$store.state.global.busquedaGlobal;
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  data() {
    return {
      dialogCerrarSesion: false,
      menuBuscador: false,
      menuUsuario: false,
      menuCrearRecurso: false,
      isFlat: true,
      valueFieldSearch: ""
    };
  },
  computed: {
    user: function() {
      return this.$store.state.authentication.user;
    }
  },
  watch: {
    valueFieldSearch: function(val) {
      this.$store.commit("global/SET_BusquedaGlobal", val);
    },
    busquedaGlobal: function(val) {
      this.valueFieldSearch = val;
    }
  },
  methods: {
    handleScroll() {
      this.isFlat = window.scrollY < 5;
    },
    showMenuBuscador() {
      var that = this;
      setTimeout(function() {
        that.menuBuscador = true;
      }, 100);
    },
    hideMenuBuscador() {
      this.menuBuscador = false;
    },
    cerrarSesion() {
      const { dispatch } = this.$store;
      dispatch("authentication/logout");
    }
  },
  directives: {
    ClickOutside
  }
};
</script>


<style lang="scss">
#iconMenu {
  position: relative;

  #chincheta {
    position: absolute;
    left: 28px;
    top: 25px;
    font-size: 11px;
    color: #fdcf00;
    background-color: var(--v-primary-base);
    padding: 2px;
  }
  &:hover #chincheta {
    background-color: #3d92f0;
  }
  &:focus #chincheta {
    background-color: #3d92f0;
  }
}

.v-application .v-btn--icon.v-size--small {
  height: 30px;
  width: 30px;
}

.toolbarPrincipal .v-toolbar__content {
  background-color: var(--v-primary-base);
}

.theme--dark.v-text-field--solo-inverted.v-text-field--solo
  > .v-input__control
  > .v-input__slot {
  background-color: #1e88e5;
  margin-top: 10px;
}

.v-icon.material-icons.theme--dark.white--text {
  color: #1e88e5 !important;
}

.v-list.acciones a {
  text-decoration: none;
  color: #78909c;
}
.v-list.acciones .v-list__tile__action i {
  margin-left: 0.75rem;
  color: #78909c;
}

.menuBuscador {
  margin-top: -24px;
  background-color: #f8fafc;
}
</style>